const appConfig = Object.assign(APP_CONFIG, { featureFlag: true });
export default appConfig;
